import { useSelector } from "react-redux";

export default function Footer() {
  const { msg } = useSelector((state) => state.language);
  return <div className="_footer">{msg["copyright"]}</div>;
}
